import React from "react";
import "../home.css";
import { motion } from "framer-motion";

const icons = [
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="white"
    width="32"
    height="32"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M13 16h-1v-4h-1m1 4V8m-1 8v-8"
    />
  </svg>,
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="white"
    width="32"
    height="32"
  >
    <rect width="18" height="13" x="3" y="7" rx="2" strokeWidth="2" />
  </svg>,
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="white"
    width="32"
    height="32"
  >
    <circle cx="12" cy="7" r="3" />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 14v7"
    />
  </svg>,
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="white"
    width="32"
    height="32"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M18 7V5a3 3 0 00-3-3h-6a3 3 0 00-3 3v2"
    />
  </svg>,
];
const companiesRow1 = [
  "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg",
  "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg",
  "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/a2b3c3709ffedce2a22a.png",
  "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/3cd767dea94a85078ca4.png",
  "https://cdn.worldvectorlogo.com/logos/infosys-3.svg",
  "https://cdn.worldvectorlogo.com/logos/wipro-1.svg",
  "https://images.seeklogo.com/logo-png/30/2/tech-mahindra-logo-png_seeklogo-304147.png",
  "https://cdn.worldvectorlogo.com/logos/capgemini-201x-logo.svg",
  "https://cdn.worldvectorlogo.com/logos/ey.svg",
  "https://cdn.worldvectorlogo.com/logos/zoho-1.svg",
  "https://cdn.worldvectorlogo.com/logos/flipkart.svg",
  "https://cdn.worldvectorlogo.com/logos/paytm-1.svg",
];

const companiesRow2 = [
  "https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg",
  "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
  "https://cdn.worldvectorlogo.com/logos/tata-consultancy-services-1.svg",
  "https://cdn.worldvectorlogo.com/logos/hcltech-1.svg",
  "https://cdn.worldvectorlogo.com/logos/cognizant-1.svg",
  "https://cdn.worldvectorlogo.com/logos/swiggy-logo.svg",
  "https://cdn.worldvectorlogo.com/logos/accenture-6.svg",
  "https://cdn.worldvectorlogo.com/logos/google-pay-2.svg",
  "https://cdn.worldvectorlogo.com/logos/zomato-1.svg",
  "https://cdn.worldvectorlogo.com/logos/spotify-logo.svg",
  "https://cdn.worldvectorlogo.com/logos/uber-2.svg",
  "https://cdn.worldvectorlogo.com/logos/meta-3.svg",
];

const cardData = [
  {
    img: "https://images.unsplash.com/photo-1508317469940-e3de49ba902e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8c2tpbGx8ZW58MHx8MHx8fDA%3D",
    title: "Real Skills, Real Results",
    desc: "Hands-on projects built with industry-level standards.",
  },
  {
    img: "https://images.pexels.com/photos/7688460/pexels-photo-7688460.jpeg",
    title: "Internships That Matter",
    desc: "Real company projects with mentorship.",
  },
  {
    img: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8bWVudG9yaW5nfGVufDB8fDB8fHww",
    title: "Mentorship That Empowers",
    desc: "1:1 sessions with experienced engineers.",
  },
  {
    img: "https://images.unsplash.com/photo-1730382624709-81e52dd294d4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Z3Jvd3RofGVufDB8fDB8fHww",
    title: "One Platform, Endless Growth",
    desc: "Learn at your pace with structured pathways.",
  },
];

function Company() {
  const [animate, setAnimate] = React.useState(false);

  React.useEffect(() => {
    const cards = document.querySelectorAll(".card-custom");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("card-animate");
            entry.target.classList.remove("card-pre-hidden");

            observer.unobserve(entry.target);
          }
        });
      },
      // { threshold: 0.15 }
      {
        threshold: 0,
        // rootMargin: "0px 0px -5% 0px"
        rootMargin: "0px 0px 0px 0px",
      }
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="bg-white min-h-screen">
      <div className="pt-8 pb-3">
        <div className="section-title font-semibold">
          Our Learners Are Shaping Their Careers At
        </div>

        <div className="logo-wrapper">
          <div className="logo-slider">
            <div className="logo-track left">
              {[...companiesRow1, ...companiesRow1].map((logo, i) => (
                <img loading="lazy" key={i} src={logo} alt="logo" />
              ))}
            </div>
          </div>

          <div className="logo-slider">
            <div className="logo-track right">
              {[...companiesRow2, ...companiesRow2].map((logo, i) => (
                <img loading="lazy" key={i} src={logo} alt="company-logo" />
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="choose-us" style={{ textAlign: "center", marginTop: "60px" }}>
        <h2 
          style={{
            fontSize: "2.5rem",
            fontWeight: "800",
            marginBottom: "15px",
          }}
        >
          Why Choose Us?
        </h2>
        <p style={{ marginBottom: "50px", fontSize: "18px", opacity: 0.7 }}>
          One Click. Endless Learning—upgrade your skills with practical, career-focused training.
        </p>

        <div className="feature-container">
          {cardData.map((item, index) => (
            <motion.div
              key={index}
              className="feature-card"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7, delay: index * 0.4 }}
              viewport={{ once: true }}
            >
              <img src={item.img} alt={item.title} className="feature-img" />
              <div className="feature-text">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Company;
